import useApi, { ApiOptions } from '../base/useApi';
import UserCrewMemberListItemDTO from '@src/adapters/dto/user/UserCrewMemberListItemDTO';

interface Params {}

interface Result {
  members: UserCrewMemberListItemDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/user/crew_members_list/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindCrewListLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindCrewListLazy;
